module.exports = __webpack_public_path__ + "img/accent-grave.86922f2b.svg";